/**
 * Transform a number into an ergonomically readable string
 *
 * e.g.
 * Convert 500000 into a '500,000' string
 */
export function commaSeparatedNumber(num: number): string {
  const characters = num.toString()

  const data = Array.from(characters).reduceRight((acc: string[][], char: string) => {
    const headChunk = acc?.[0] ?? []
    return headChunk.length === 3 ?
        [[char], ...acc] :
        [[char, ...headChunk], ...acc.slice(1)]
  }, [])

  return data
    .map(charList => charList.join(''))
    .join(',')
}

const DIRTY_CHARS_PATTERN = /[^0-9|^.]/g
/**
 * Transform a formatted number string into a value of type `number`
 *
 * e.g.
 * $400.50 => 400.5
 * AUD400.5067 => 400.5067
 *
 * @remarks
 * In the case of an invalid number with multiple decimal points
 *
 * i.e.
 * 100.10.10
 *
 * We only consider the first `.`
 * Transformed value in this case is: 100.1
 */
export function formattedStringNumberToValue(numStr: string): number {
  if (!numStr) { return 0 }
  const cleanedStr = numStr.replaceAll(DIRTY_CHARS_PATTERN, '')

  // Handle multiple `.` chars
  const delimiterIdx = cleanedStr.indexOf('.')
  const result = (delimiterIdx === -1 || delimiterIdx === cleanedStr.length - 1) ?
    cleanedStr :
    cleanedStr.slice(0, delimiterIdx + 1).concat(cleanedStr.slice(delimiterIdx + 1).replaceAll('.', ''))

  return Number(result)
}
